//dependencias
import React, { Component } from "react";
import { connect } from "react-redux";

//componentes
import ConsultaIT2Action from "./consultaIT2";

class Index extends Component {
  render() {
    return (
      <div>
        <ConsultaIT2Action {...this.props} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  usuario1: state.usuario1,
});

export default connect(mapStateToProps)(Index);
